import { DataLabel, DynamicFormRequiredType, RequiredIndicator } from '@myosh/odin-components';
import type { Caption } from '../../@types/common';

interface FormBuilderLabelFieldProps {
  label: string;
  required?: DynamicFormRequiredType;
  fieldData?: Caption;
}

function FormBuilderLabelField({ label, required, fieldData }: FormBuilderLabelFieldProps) {
  const additionalDisplayData = fieldData?.translations?.[0]?.value;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex">
        <p className="text-sm font-bold">{label}</p>
        {required === DynamicFormRequiredType.True && <RequiredIndicator readOnly={false} required={required} />}
      </div>
      <DataLabel value={additionalDisplayData} />
    </div>
  );
}

export default FormBuilderLabelField;
